import React from "react";
import { AiFillCloseCircle } from "react-icons/ai";

const WarningModal = ({ message, closeModal }) => {
  return (
    <div>
      <div className="flex w-full md:w-1/3 mmax-w-sm mx-auto overflow-hidden bg-white rounded-lg shadow-md dark:bg-gray-800">
        <div className="w-10 flex items-center justify-center md:w-12 bg-yellow-400">
          <svg
            className="w-6 h-6 text-white fill-current"
            viewBox="0 0 40 40"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M20 3.33331C10.8 3.33331 3.33337 10.8 3.33337 20C3.33337 29.2 10.8 36.6666 20 36.6666C29.2 36.6666 36.6667 29.2 36.6667 20C36.6667 10.8 29.2 3.33331 20 3.33331ZM21.6667 28.3333H18.3334V25H21.6667V28.3333ZM21.6667 21.6666H18.3334V11.6666H21.6667V21.6666Z" />
          </svg>
        </div>

        <div className="flex w-full justify-between items-center px-2 py-2 md:px-4 ">
          <div className="mx-3 mt-2">
            <div>
              <span className="font-semibold text-yellow-400 dark:text-yellow-300">
                Warning
              </span>
              <p className="text-sm text-gray-600 dark:text-gray-200">
                {message}
              </p>
            </div>
          </div>
          <button onClick={closeModal}>
            <AiFillCloseCircle size="1.3rem" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default WarningModal;
